export
const name: string = "LightingSimpleInVs";

export
const preproc: string = ``;

export
const declaration: string = `
    uniform       int    u_ambient_is_diffuse;
    uniform       float  u_ambient_light_intensity;
`;

export
const varyings: string = `
    varying       vec3   v_simple_diffuse_color;
    varying       vec3   v_simple_specular_color;
`;

export
const implementation: string = `
    lowp vec4 applyLighting(const SMaterial aSurfaceMaterial)
    {
         // when the ambient equals diffuse color uniform is enabled, then instead of using the surface ambient color, we use the diffuse color
        vec3 ambientSurfaceColor = aSurfaceMaterial.ambient;
        if (u_ambient_is_diffuse == 1) {
             ambientSurfaceColor = aSurfaceMaterial.diffuse;
        }

        return vec4(ambientSurfaceColor * u_ambient_light_intensity + aSurfaceMaterial.diffuse * v_simple_diffuse_color + aSurfaceMaterial.specular * v_simple_specular_color, aSurfaceMaterial.alpha * (1.0 - aSurfaceMaterial.transparency));
    }
`;
